<template>
    <ExtraDetails
        :experience="user.experience"
        :mobile="user.mobile"
        :setMobile="setMobile"
        :setResidencyCountry="setResidencyCountry"
        :countryOfResidence="countryOfResidence"
        :getIsoCodeFromName="getIsoCodeFromName"
    >
        <template slot="header">
            <h1
                class="mb-2"
                v-translate
            >Sign up to SmartCharts</h1>
        </template>
        <template slot="footer" slot-scope="{ submitForm, isValid }">
            <div class="row align-items-center">
                <div class="col-sm-auto ml-auto mt-2 mt-sm-0">
                    <LoaderedButton
                        :clickHandler="submitForm"
                        btnClasses="btn btn-primary btn-full"
                        :content="'Next' | translate"
                        :isValid="isValid"
                    />
                </div>
            </div>
        </template>
    </ExtraDetails>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import ExtraDetails from '@C/Enrolment/ExtraDetails';
import LoaderedButton from '@C/LoaderedButton';
import CustomSelect from '@C/CustomSelect';

import autocomplete from '@M/autocomplete';
import marketing from '@M/marketing';

export default {
    name: 'MarketingStep2',
    mixins: [autocomplete('Marketing'), marketing],
    components: {
        LoaderedButton,
        CustomSelect,
        ExtraDetails
    },
    computed: {
        ...mapState(['bus', 'language']),
        ...mapState('Marketing', ['user']),
        ...mapState('Marketing', {
            countryOfResidence: 'country_of_residence'
        })
    },
    beforeDestroy() {
        this.bus.$off('update:detail');
        this.bus.$off('form:submit');
    },
    mounted() {
        this.bus.$on('update:detail', this.updateState);
        this.bus.$on('form:submit', this.formHandler);
    },
    methods: {
        ...mapActions({
            setLanguage: 'setLanguage'
        }),
        ...mapActions('Marketing', ['step2']),
        ...mapMutations('Marketing', {
            setResidencyCountry: 'country_of_residence'
        }),
        ...mapMutations('Marketing', ['updateState', 'setMobile']),
        formHandler() {
            this.step2();
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Marketing/Step2.vue